import { ContentEntityType, ContentEntityTypeValues } from "@/types";

/**
 * Depth of each entity kind in the content hierarchy
 * (`platform → federation → league → tournament`).
 *
 * Content may only be tagged **downward** (onto strictly lower entities) and
 * only shared **upward** (onto strictly higher ones). The backend is the
 * enforcement point — these helpers only keep the UI from offering a write the
 * API would reject.
 */
export const CONTENT_ENTITY_LEVEL: { [key in ContentEntityType]: number } = {
  platform: 0,
  federation: 1,
  league: 2,
  tournament: 3,
};

export const isStrictlyLowerContentEntity = (
  owner: ContentEntityType,
  target: ContentEntityType
): boolean => CONTENT_ENTITY_LEVEL[target] > CONTENT_ENTITY_LEVEL[owner];

export const isStrictlyHigherContentEntity = (
  owner: ContentEntityType,
  sharer: ContentEntityType
): boolean => CONTENT_ENTITY_LEVEL[sharer] < CONTENT_ENTITY_LEVEL[owner];

/** Entity kinds the given owner may tag its content onto, top-down. */
export const getTaggableContentEntityTypes = (owner: ContentEntityType): ContentEntityType[] =>
  ContentEntityTypeValues.filter((target) => isStrictlyLowerContentEntity(owner, target));
